import TagManager from 'react-gtm-module';

export default function GTM() {
  try {
    // Verificar se o GTM já foi inicializado
    if (!window.dataLayer) {
      const tagManagerArgs = {
        gtmId: 'GTM-WNM479C',
      };

      TagManager.initialize(tagManagerArgs);
    }
  } catch (e) {
    console.log("GTM Error init: ", e);
  }
}
